const AG_GRID_LOCALE_RU = {
 // for filter panel
 page: 'Страница',
 more: 'ещё',
 to: 'к',
 of: 'из',
 next: 'Следующая',
 last: 'Последняя',
 first: 'Первая',
 previous: 'Предыдущая',
 loadingOoo: 'Загрузка...',

 // for set filter
 selectAll: 'Выделить всё',
 searchOoo: 'Поиск...',
 blanks: 'Ничего не найдено',

 // for number filter and text filter
 filterOoo: 'Фильтровать...',
 applyFilter: 'Применить фильтр',
 equals: 'Равно',
 notEqual: 'Не равно',
 blank: 'Пустой',
 notBlank: 'Не пустой',
 empty: 'Choose Ooooooooooone',
 resetFilterButton: 'Сбросить',
 resetFilter: 'Сбросить',

 // for number filter
 lessThan: 'Меньше чем',
 greaterThan: 'Больше чем',
 lessThanOrEqual: 'Меньше или равно',
 greaterThanOrEqual: 'Больше или равно',
 inRange: 'В промежутке',

 // for text filter
 contains: 'Содержит',
 notContains: 'Не содержит',
 startsWith: 'Начинается с',
 endsWith: 'Заканчивается',

 // filter conditions
 andCondition: '"И"',
 orCondition: '"ИЛИ"',

 // the header of the default group column
 group: 'Группа',

 // tool panel
 columns: 'Столбцы',
 filters: 'Фильтры',
 rowGroupColumns: 'Столбцы группировки по строкам',
 rowGroupColumnsEmptyMessage: 'Перетащите сюда для группировки по строкам',
 valueColumns: 'Столбцы со значениями',
 pivotMode: 'Режим сводной таблицы',
 groups: 'Группы',
 values: 'Значения',
 pivots: 'Заголовки столбцов',
 valueColumnsEmptyMessage: 'Перетащите сюда для агрегации',
 pivotColumnsEmptyMessage: 'Перетащите сюда, чтобы задать заголовки столбам',
 toolPanelButton: 'Панель инструментов',

 // other
 noRowsToShow: 'Нет данных',

 // enterprise menu
 pinColumn: 'Закрепить колонку',
 valueAggregation: 'Агрегация по значению',
 autosizeThiscolumn: 'Автоматически задавать размер этой колонки',
 autosizeAllColumns: 'Автоматически задавать размер всем колонкам',
 groupBy: 'Группировать по',
 ungroupBy: 'Разгруппировать по',
 resetColumns: 'Сбросить столбцы',
 expandAll: 'Развернуть всё',
 collapseAll: 'Свернуть всё',
 toolPanel: 'Панель инструментов',
 export: 'Экспорт',
 csvExport: 'Экспорт в CSV',
 excelExport: 'Экспорт в Excel (.xlsx)',
 excelXmlExport: 'Экспорт в XML (.xml)',

 // enterprise menu pinning
 pinLeft: 'Закрепить слева <<',
 pinRight: 'Закрепить справа >>',
 noPin: 'Не закреплять <>',

 // enterprise menu aggregation and status bar
 sum: 'Сумма',
 min: 'Минимум',
 max: 'Максимум',
 none: 'Пусто',
 count: 'Количество',
 average: 'Среднее значение',
 filteredRows: 'Отфильтрованные',
 selectedRows: 'Выделенные',
 totalRows: 'Всего строк',
 totalAndFilteredRows: 'Строк',

 // standard menu
 cut: 'Вырезать',
 copy: 'Копировать',
 copyWithHeaders: 'Копировать с заголовком',
 copyWithGroupHeaders: 'Копировать с заголовками группы',
 ctrlC: 'Ctrl+C',
 paste: 'Вставить',
 ctrlV: 'Ctrl+V',
};

export default AG_GRID_LOCALE_RU;
